import script from "./CompanionEnding.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanionEnding.vue?vue&type=script&lang=ts&setup=true"

import "./CompanionEnding.vue?vue&type=style&index=0&id=2c1d7d62&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src462465770/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c1d7d62"]])

export default __exports__